module.exports = __webpack_public_path__ + "img/audio.45abe037.png";